import { NyalaCustomer } from '@src/types/NyalaCustomer'
import { api, ApiRes } from './client'

export interface NyalaCustomerResponse {
    success: boolean
    nyalaCustomer: NyalaCustomer | null
}

export const getNyalaCustomerForNaturalProfile = (
    id: string
): ApiRes<NyalaCustomerResponse> =>
    api.get(`manage/nyala-customers/natural-profiles/${id}`)

export const getNyalaCustomerForLegalProfile = (
    id: string
): ApiRes<NyalaCustomerResponse> =>
    api.get(`manage/nyala-customers/legal-profiles/${id}`)
